<template>
  <div class="typing-bar">
    <div @click="leaveEvent" class="typing-button">
      <font-awesome-icon icon="sign-out-alt" />
    </div>
    <label v-show="!pending" class="sending-button typing-button">
      <font-awesome-icon icon="image" />
      <input type="file" class="photo-input" accept="image/*" @change="photoUpload">
    </label>
    <div v-show="pending">
      <font-awesome-icon icon="spinner" />
    </div>

    <form class="text-wrapper" @submit.prevent="sendingMessage">
      <input class="typing-text" placeholder="請輸入訊息" autocomplete="no" maxlength="100" />
      <!--<div class="photo typing-button" @click="sendPhoto">Photo</div>-->
      <button @click="sendingMessage" class="typing-button" style="position:absolute;right:10px;background:none;border:none;">
        <font-awesome-icon icon="arrow-right" />
      </button>
    </form>
  </div>
</template>
<script>
//import autosize from 'autosize';
import { mapState, mapMutations } from 'vuex';
export default {
  data() {
    return {
      pending: false,
      typingText: null // a dom,
    };
  },
  computed: {
    ...mapState('information', ['sex', 'city'])
  },
  methods: {
    ...mapMutations('chat', ['messagePush']),
    leaveEvent() {
      if (!window.confirm('確定離開嗎？')) return;
      if (this.$socket.connected) this.$socket.close();
      //      this.message = [];
      this.messagePush({
        time: Date.now(),
        who: 'system',
        text: '已斷開連接',
        state: ''
      });
    },
    sendingMessage() {
      let area = this.typingText;
      //area.style.height = '28px';
      //regex to trim space
      if (/\S/.test(area.value)) {
        let ts = Date.now();
        this.messagePush({
          time: ts,
          who: 'me',
          text: area.value,
          state: 'nothing'
        });
        this.scrollMessageToBottom();
        if (this.$socket.connected)
          this.$socket.send({
            text: area.value,
            time: ts,
            sex: this.sex
          });
        area.focus();
      }
      area.value = '';
    },
    scrollMessageToBottom() {
      let content = document.querySelector('.content');
      this.$nextTick().then(() => {
        content.scrollTop = content.scrollHeight;
      });
    },
    photoUpload(e) {
      //let target = e.target.files[0];
      //let photo = document.querySelector('.photo');

      this.pending = true;

      const api = 'https://api.imgur.com/3/image';
      const image = new Blob(e.target.files, {
        type: 'image/png'
      });
      const formData = new FormData();
      formData.append('image', image);
      this.$http
        .post(api, formData, {
          headers: {
            Authorization: 'Client-ID 1109468ed7c4606'
          }
        })
        .then(res => {
          this.typingText.value += ` ${res.data.data.link}`;
        })
        .catch(err => {
          // eslint-disable-next-line
          console.log(err);
        })
        .finally(() => {
          this.pending = false;
          document.querySelector('input.photo-input').value = '';
        });
    }
  },
  mounted() {
    this.typingText = document.querySelector('.typing-text');
    //alert(this.typingText);
    //autosize(this.typingText); // for typing message area
  }
};
</script>
<style lang="scss" scoped>
.typing-bar {
  padding: 0px 5px;
  flex-shrink: 0;
  width: 100%;
  min-height: 45px;
  background-color: rgb(240, 240, 240);
  display: flex;
  justify-content: space-between;
  & > * {
    line-height: 18px;
    margin: 4px 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  & > .text-wrapper {
    flex-shrink: 1;
    position: relative;
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
  .typing-text {
    box-sizing: content-box;
    padding-right: 25px;
    font-size: 18px;
    line-height: 36px;
    &::placeholder {
      opacity: 0.5;
    }
    //height: 28px;
    padding-left: 10px;
    outline: none;
    resize: none;
    border: none;
    border-radius: 15px;
  }
  .typing-button {
    font-size: 20px;
    cursor: pointer;
    color: gray;
  }
  /*
  .photo {
    position: absolute;
    right: 10px;
    input {
      display: none;
    }
  }*/
  .sending-button {
    display: flex;
    input {
      display: none;
    }
  }
}
</style>
